import { render } from "./Resume5.vue?vue&type=template&id=69986681&scoped=true"
import script from "./Resume5.vue?vue&type=script&lang=js"
export * from "./Resume5.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-69986681"

export default script